<template>

    <!-- Modal -->
    <div class="modal fade" id="modalTarifa" data-bs-backdrop="static" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">

                <div class="modal-header">
                    <h5 class="modal-title">
                        {{ modalAlta ? tituloModulo : `EDITAR ${tituloModulo}` }}
                    </h5>

                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        @click="cerrar"
                    ></button>
                </div>

                <div class="modal-body">

                    <!-- Precio máximo -->
                    <div class="py-1 row" >
                        <div class="col-md-3" style="display:none">
                            <label>Precio Máximo *</label>
                        </div>

                        <div class="col-md-9" style="display:none">
                            <div class="input-group">
                                <span class="input-group-text">$</span>

                                <input
                                    type="number"
                                    step="0.01"
                                    class="form-control"
                                    v-model="form.precio_maximo"
                                >
                            </div>
                        </div>
                    </div>

                     <div class="row align-items-center mb-3">
    <div class="col-md-3">
        <label class="mb-0">Unidad *</label>
    </div>

    <div class="col-md-9">
        <input type="text" class="form-control" v-model="form.unidad" readonly>
    </div>
</div>
                    <!-- Rango MW -->
                    <div class="row py-1">

                        <div class="col-md-3">
                            <label>De {{ form.unidad || 'Unidad' }} *</label>
                        </div>

                        <div class="col-md-3">
                            <input
                                type="number"
                                class="form-control"
                                v-model="form.mw_de"
                            >
                        </div>


                        <div class="col-md-3">
                            <label>A {{ form.unidad || 'Unidad' }} *</label>
                        </div>

                        <div class="col-md-3">
                            <input
                                type="number"
                                class="form-control"
                                v-model="form.mw_a"
                            >
                        </div>

                    </div>


                    <!-- Cálculo -->
                    <div class="py-1 row">

                        <div class="col-md-3">
                            <label>Cálculo (redondeado a 500)</label>
                        </div>

                        <div class="col-md-9">
                            <input
                                type="number"
                                class="form-control"
                                v-model="form.calculo_redondeado"
                            >
                        </div>

                    </div>



                    <!-- HORAS -->
                    <h6 class="mt-3">HORAS</h6>

                    <div class="row">

                        <div class="col-md-4">
                            <label>IR</label>
                            <input class="form-control" v-model="form.horas_ir" @input="calcular">
                        </div>


                        <div class="col-md-4">
                            <label>IRS</label>
                            <input class="form-control" v-model="form.horas_irs" @input="calcular">
                        </div>


                        <div class="col-md-4">
                            <label>I</label>
                            <input class="form-control" v-model="form.horas_i" @input="calcular">
                        </div>

                    </div>



                    <!-- COSTOS -->
                    <h6 class="mt-3">COSTOS</h6>

                    <div class="row">

                        <div class="col-md-4">
                            <label>IR</label>

                            <input
                                type="number"
                                step="0.01"
                                class="form-control"
                                v-model="form.costo_ir"
                            >
                        </div>


                        <div class="col-md-4">
                            <label>IRS</label>

                            <input
                                type="number"
                                step="0.01"
                                class="form-control"
                                v-model="form.costo_irs"
                            >
                        </div>


                        <div class="col-md-4">
                            <label>I</label>

                            <input
                                type="number"
                                step="0.01"
                                class="form-control"
                                v-model="form.costo_i"
                            >
                        </div>

                    </div>


                </div>

                <div class="modal-footer">

                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                        ref="btnCerrar"
                    >
                        Cancelar
                    </button>

                    <button
                        v-if="modalAlta"
                        type="button"
                        class="btn"
                        style="background-color:#F49315;color:white;"
                        @click="guardar"
                    >
                        Guardar
                    </button>

                    <button
                        v-else
                        type="button"
                        class="btn"
                        style="background-color:#F49315;color:white;"
                        @click="actualizar"
                    >
                        Actualizar
                    </button>

                </div>

            </div>
        </div>
    </div>

    <!-- Encabezado -->

    <div class="col-md-12" style="text-align: left;">

        <h4 style="text-align: left;">{{ tituloModulo  }}</h4>

        <br>

        <button
            class="btn"
            style="background-color:#F49315;color:white; "
            data-bs-toggle="modal"
            data-bs-target="#modalTarifa"
            @click="nuevoRegistro"
        >
            Nuevo
        </button>

    </div>

    <br>

    <div class="col-md-12 mb-3">
    <div class="d-flex align-items-center gap-2 flex-wrap">

        <label class="mb-0">Buscar columna:</label>

        <select
            class="form-control"
            style="width: 220px;"
            v-model="searchField"
        >
            <option value="unidad">Unidad</option>
            <option value="mw_de">De</option>
            <option value="mw_a">A</option>
            <option value="calculo_redondeado">Cálculo redondeado</option>
            <option value="horas_ir">Horas IR</option>
            <option value="horas_irs">Horas IRS</option>
            <option value="horas_i">Horas I</option>
            <option value="costo_ir">Costo IR</option>
            <option value="costo_irs">Costo IRS</option>
            <option value="costo_i">Costo I</option>
        </select>

        <label class="mb-0">Buscar:</label>

        <input
            type="text"
            class="form-control"
            style="width: 250px;"
            v-model="searchValue"
            placeholder="Escriba para buscar..."
        >

    </div>
</div>

    <br>

    <EasyDataTable
        :headers="headers"
        :items="tarifas"
        :search-field="searchField"
        :search-value="searchValue"
    >

        <template #item-precio="item">
            {{
                Number(item.precio).toLocaleString(
                    'es-MX',
                    {
                        style:'currency',
                        currency:'MXN'
                    }
                )
            }}
        </template>

        <template #item-operation="item">

            <!--<button
                type="button"
                class=" btn btn-sm fa fa-eye"
                style="background-color: #F49315; color: white;"
                data-bs-toggle="modal"
                data-bs-target="#modalTarifa"
                @click="editar(item)"
            ></button>-->
            <button class="btn btn-light btn-sm" type="button" @click="editar(item)"
            data-bs-toggle="modal"
                data-bs-target="#modalTarifa"
                ><span class="fa fa-eye" style="color:#F49315;"></span></button> &nbsp;


            

            <!--<button
                type="button"
                class="btn btn-sm fa fa-trash btn-danger"
                @click="eliminar(item)"
            ></button>-->
            <button class="btn btn-light btn-sm" type="button" @click="eliminar(item)"
           
                ><span class="fa fa-trash" style="color:red;"></span></button>

        </template>

    </EasyDataTable>

</template>

<script>

import axios from "axios";
import Swal from "sweetalert2";

export default {

    name: "Tarifas",

    data() {

        return {

            modalAlta: true,

            searchField: "unidad",
            searchValue: "",

            tarifas: [],

            headers: [
                {
                    text: "Unidad",
                    value: "unidad",
                    sortable: true
                },
                {
                    text: "De",
                    value: "mw_de",
                    sortable: true
                },
                {
                    text: "A",
                    value: "mw_a",
                    sortable: true
                },
                {
                    text: "Calculo",
                    value: "calculo_redondeado",
                    sortable: true
                },
                {
                    text: "IR Horas",
                    value: "horas_ir",
                    sortable: true
                },
                {
                    text: "IRS Horas",
                    value: "horas_irs"
                },
                {
                    text: "I Horas",
                    value: "horas_i",
                    sortable: true
                },
                {
                    text: "IR Costo",
                    value: "costo_ir",
                    sortable: true
                },
                {
                    text: "IRS Costo",
                    value: "costo_irs"
                },
                {
                    text: "I Costo",
                    value: "costo_i",
                    sortable: true
                },
                {
                    text: "Operación",
                    value: "operation"
                }
            ],

            form: {
                id:'',
                
                nivel: '',
                unidad: this.$route.meta.unidad,

                precio_maximo: '',
                mw_de:'',
                mw_a:'',
                calculo_redondeado:'',
                
                horas_ir:'',
                horas_irs:'',
                horas_i:'',

                costo_ir:'',
                costo_irs:'',
                costo_i:'',
                tipo: this.$route.meta.tipo,
                nivel: this.$route.meta.nivel
            },
            
        };
    },

    mounted() {
        this.form.unidad = this.$route.meta.unidad;
        this.form.tipo = this.$route.meta.tipo;
        this.form.nivel = this.$route.meta.nivel;
        
        this.consultar();

    },

    methods: {
        calcular(){

            let costoIR = (this.form.horas_ir || 0) * 4700;
            let costoIRS = (this.form.horas_irs || 0) * 2800;
            let costoI = (this.form.horas_i || 0) * 1900;


            this.form.costo_ir = costoIR;
            this.form.costo_irs = costoIRS;
            this.form.costo_i = costoI;


            let suma = costoIR + costoIRS + costoI;
            this.form.calculo_redondeado = Math.round(suma / 500) * 500;
            
        },

        nuevoRegistro() {

            this.modalAlta = true;

            this.form = {
                id:"",
                unidad: this.$route.meta.unidad,
                precio_maximo: '',
                mw_de:'',
                mw_a:'',
                calculo_redondeado:'',
                
                horas_ir:'',
                horas_irs:'',
                horas_i:'',

                costo_ir:'',
                costo_irs:'',
                costo_i:'',
                tipo: this.$route.meta.tipo,
                nivel: this.$route.meta.nivel
            };

        },

        editar(item) {

            this.modalAlta = false;

             this.form = {
                ...this.form,
                ...item
            };

        },

        guardar() {

            axios.post(
                this.$rutaServer + "guardarTarifa",
                this.form
            )
            .then(() => {

                Swal.fire(
                    "Éxito",
                    "Tarifa guardada correctamente",
                    "success"
                );

                this.consultar();

                this.$refs.btnCerrar.click();

            });

        },

        actualizar() {

            axios.post(
                this.$rutaServer + "actualizarTarifa",
                this.form
            )
            .then(() => {

                Swal.fire(
                    "Éxito",
                    "Tarifa actualizada correctamente",
                    "success"
                );

                this.consultar();

                this.$refs.btnCerrar.click();

            });

        },

        async eliminar(item) {

            const result = await Swal.fire({
                title: '¿Eliminar?',
                text: 'Esta acción no se puede deshacer',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) {
                return;
            }

            axios.post(
                this.$rutaServer + "eliminarTarifa",
                {
                    id: item.id
                }
            )
            .then(() => {

                Swal.fire(
                    "Éxito",
                    "Tarifa eliminada",
                    "success"
                );

                this.consultar();

            });

        },

        consultar() {
            console.log(this.descripcionConsulta);
            axios.post(
                this.$rutaServer + "consultarTarifas", {
                descripcion: this.descripcionConsulta
            }
            )
            .then(response => {
                console.log(response.data.data);
                this.tarifas = response.data.data;

            });

        },

        cerrar() {

             this.form =  {
                id:'',
                
                nivel: '',
                unidad: this.$route.meta.unidad,

                precio_maximo: '',
                mw_de:'',
                mw_a:'',
                calculo_redondeado:'',
                
                horas_ir:'',
                horas_irs:'',
                horas_i:'',

                costo_ir:'',
                costo_irs:'',
                costo_i:'',
                tipo: this.$route.meta.tipo,
                nivel: this.$route.meta.nivel
            }

        }

    },
    computed: {
        tituloModulo() {
            
            if (this.form.tipo === 'GD') {
                return 'GENERACIÓN DISTRIBUIDA';
            }

            if (this.form.tipo === 'CO') {
                return `CENTROS DE CARGA ${this.form.nivel.toUpperCase()}`;
            }

            if (this.form.tipo === 'COT') {
                return `CENTROS DE CARGA ${this.form.nivel.toUpperCase()}`;
            }

            if (this.form.tipo === 'CI' || this.form.tipo === 'CIT') {
                return `CENTRALES ELÉCTRICAS ${this.form.nivel.toUpperCase()}`;
            }


                return 'ARANCELES';
        },
        descripcionConsulta() {

            if (this.form.tipo === 'GD') {
                return `Generación Distribuida - MT - ${this.form.unidad}`;
            }

            if (this.form.tipo === 'CO') {
                return `Centros de Carga ${this.form.nivel} - MT - ${this.form.unidad}`;
            }

            if (this.form.tipo === 'COT') {
                return `Centros de Carga ${this.form.nivel} - AT - ${this.form.unidad}`;
            }

            if (this.form.tipo === 'CI') {
                return `Centrales Eléctricas ${this.form.nivel} - MT - ${this.form.unidad}`;
            }

            if (this.form.tipo === 'CIT') {
                return `Centrales Eléctricas ${this.form.nivel} - AT - ${this.form.unidad}`;
            }

            return '';
        }
    },
    watch: {
        $route(to) {
            /*this.form.unidad = to.meta.unidad;
            this.form.tipo = to.meta.tipo;
            this.form.nivel = to.meta.nivel || '';*/
            this.form = {
                ...this.form,
                unidad: to.meta.unidad,
                tipo: to.meta.tipo,
                nivel: to.meta.nivel || ''
            };

            this.$nextTick(() => {
                this.consultar();
            });
        }
    }

};

</script>